import * as React from 'react';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFnsV3';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';

export const DateTimePickerInput = ({
  closeFunction,
  defaultText,
  icon,
  initialValue,
  key,
  timeFormat
}: {
  closeFunction: Function,
  defaultText?: string,
  icon?: any
  initialValue?: string | any;
  key?: string;
  timeFormat?: string;
}) => {
  const initalDate = initialValue ? new Date(initialValue) : null;
  const [selectedDate, setSelectedDate] = React.useState(initalDate);

  // Called whenever the value changes.
  function handleChange(newValue) {
    setSelectedDate(newValue);
  };

  function handleAccept(newValue) {
    if (closeFunction) {
      closeFunction(newValue);
    }
  };

  // When the text field loses focus (after keyboard input), treat it as an accept.
  function handleBlur(e) {
    if (closeFunction) {
      closeFunction(selectedDate);
    }
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <div className="date-picker-container" key={key}>
        <div className="icon-and-datetime-picker">
          {icon}
          <DateTimePicker
            format={timeFormat || 'MMM d h:mm a'}
            onAccept={handleAccept}
            onChange={handleChange}
            slotProps={{
              textField: {
                inputProps: {
                  onBlur: handleBlur,
                },
                // Provide label/placeholder only when no date is selected otherwise it renders.
                placeholder: defaultText || 'Select date & time',
              },
            }}
            value={selectedDate}
          />
        </div>
      </div>
    </LocalizationProvider>
  );
};

export default DateTimePickerInput;
